module.exports = __webpack_public_path__ + "static/media/bg_trapezoid_white.3f8904cf.svg";